import { beforeNavigate, goto } from '$app/navigation';
import { page } from '$app/state';
import { currentTimeRange, type TimeRangeOption } from '#lib/timeRange.js';
import { onMount } from 'svelte';
import { writable, type Readable } from 'svelte/store';

export function onTimeRangeChange(
  callback: (val: TimeRangeOption) => void,
  applyDefault?: TimeRangeOption,
) {
  if (applyDefault !== undefined) currentTimeRange.set(applyDefault);

  onMount(() => {
    let prev: TimeRangeOption;

    return currentTimeRange.subscribe((val) => {
      if (prev === undefined) {
        prev = val;
        return;
      }

      if (prev !== val) {
        prev = val;
        callback(val);
      }
    });
  });
}

export function useTimeRange() {
  return onTimeRangeChange((val) => goto('?range=' + val), page.data.timeRange ?? 'WEEK');
}

export function preventNavIf(check: () => boolean) {
  beforeNavigate((nav) => {
    if (nav.shallow) return;
    if (check())
      if (nav.willUnload || !confirm('You have unstaged changes. Are you sure you want to leave?'))
        nav.cancel();
  });
}

export function observeClientSize(elem: () => HTMLElement): Readable<[number, number]> {
  const store = writable<[number, number]>([0, 0]);

  onMount(() => {
    const parent = elem();
    const observer = new ResizeObserver(() => {
      store.set([parent.clientWidth, parent.clientHeight]);
    });
    observer.observe(parent);

    return () => observer.disconnect();
  });

  return store;
}
